import * as actionTypes from "../../../actionTypes";
import * as api from "../../../../api/index";
import { toast } from "react-toastify";

// These three deliberately return their payload instead of going through the
// reducer: the sync screen is a workspace, not shared state, and keeping the
// comparison local avoids a stale diff being shown after a push.
export const GetTemplateSyncTargets = (setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getTemplateSyncTargetsBIZnotifications();
    setLoading(false);
    return status === 200 ? data.data : null;
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
    return null;
  }
};

export const GetLocalTemplateManifest = (setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getLocalTemplateManifestBIZnotifications();
    setLoading(false);
    return status === 200 ? data.data : null;
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
    return null;
  }
};

export const CompareTemplateSync = (target, url, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.compareTemplateSyncBIZnotifications(target, url);
    setLoading(false);
    return status === 200 ? data.data : null;
  } catch (error) {
    // the backend puts the reason (unreachable, bad secret) in `message`
    toast.error(error?.message || "Comparison failed");
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
    return null;
  }
};

// Totals per environment, so the screen can open on "what does each
// environment hold" before any comparison is run.
export const GetTemplateSyncOverview = (setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getTemplateSyncOverviewBIZnotifications();
    setLoading(false);
    return status === 200 ? data.data : null;
  } catch (error) {
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
    return null;
  }
};

// Both sides of one template, bodies included, for the diff view.
export const GetTemplateSyncDetail = (code, target, url, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.getTemplateSyncDetailBIZnotifications(code, target, url);
    setLoading(false);
    return status === 200 ? data.data : null;
  } catch (error) {
    toast.error(error?.message || "Could not load the template");
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
    return null;
  }
};

export const PushTemplateSync = (formData, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.pushTemplateSyncBIZnotifications(formData);
    if (status === 200) {
      toast.success(data.message);
      setLoading(false);
      return data.data;
    }
    dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    setLoading(false);
    return null;
  } catch (error) {
    toast.error(error?.message || "Push failed");
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
    return null;
  }
};

// The mirror of PushTemplateSync — brings templates from the remote into this
// environment, so a transfer can start from either side.
export const PullTemplateSync = (formData, setLoading) => async (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ERRORS });
  setLoading(true);
  try {
    const { data, status } = await api.pullTemplateSyncBIZnotifications(formData);
    if (status === 200) {
      toast.success(data.message);
      setLoading(false);
      return data.data;
    }
    dispatch({ type: actionTypes.SET_ERRORS, payload: data });
    setLoading(false);
    return null;
  } catch (error) {
    toast.error(error?.message || "Pull failed");
    dispatch({ type: actionTypes.SET_CRASHES, payload: error });
    setLoading(false);
    return null;
  }
};
